import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { Section } from './Section';
import { faqItems } from '../data/content';
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <Section eyebrow="Sección 7" title="Preguntas frecuentes" tone="darker" data-id="element-27" data-mp="1gitvm3ew4uj7">
      <ul className="space-y-3" data-id="element-28" data-mp="249g3nuowaet7">
        {faqItems.map((item, index) => {
        const isOpen = openIndex === index;
        const panelId = `faq-panel-${index}`;
        return <li key={item.question} className="overflow-hidden rounded-xl border border-ink-700 bg-ink-800" data-id="element-29" data-mp="28cvx6i5o3z1o" data-mpi={index}>
              <h3 data-id="element-30" data-mp="1uhk38czc6clt">
                <button type="button" aria-expanded={isOpen} aria-controls={panelId} onClick={() => setOpenIndex(isOpen ? null : index)} className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left transition-colors hover:bg-ink-700/50 focus:outline-none focus-visible:ring-2 focus-visible:ring-shield-500" data-id="element-31" data-mp="1zi7vt337r1i5">
                  <span className="font-display text-base font-bold text-white" data-id="element-32" data-mp="14wbykzj0v7zx">
                    {item.question}
                  </span>
                  <ChevronDownIcon className={`h-5 w-5 shrink-0 text-shield-500 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-33" data-mp="10rm33bs9zvfj" />
                </button>
              </h3>
              <AnimatePresence initial={false} data-id="element-34" data-mp="19sk5jpn2fuw0">
                {isOpen ? <motion.div id={panelId} key="content" initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.25,
              ease: 'easeOut'
            }} data-id="element-35" data-mp="1ohygv3a7cme1">
                    <p className="px-5 pb-5 text-sm leading-relaxed text-slate-400" data-id="element-36" data-mp="3557caz6xpvw">
                      {item.answer}
                    </p>
                  </motion.div> : null}
              </AnimatePresence>
            </li>;
      })}
      </ul>
    </Section>;
}